import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd, Routes } from '@angular/router';
import { Contact } from './contact';
import { ContactList } from './contactList';
import { Title } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  contactForm!: FormGroup;
  contactItem!: Contact;
  contactList = ContactList;
  lat = 5.60398;
  lng = 102.20528;
  navbarStatus = ".navbar-collapse";


  constructor(
    private formBuilder: FormBuilder,
    private titleService: Title,
    private http: HttpClient,
    private router: Router,
  ) {  }


  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      name: '',
      email: '',
      subject: '',
      message: ''
    })

    this.titleService.setTitle("Seng Hin Rubber (M) Sdn. Bhd.");
  }

  onSubmit() {
    const headers = { 'content-type': 'application/json' };
    
    this.contactItem = this.contactForm.value;
    this.contactList.push(this.contactForm.value);
    this.contactForm.reset();
    var theJSON = JSON.stringify(this.contactItem);
    this.http.post('http://localhost:8000/api/post', theJSON, {'headers': headers}).subscribe((response)=> console.log(response));
    alert("We have received your message. We will be contacting you soon! Thanks for your patience.");
  }

  onActivate(event: Routes){
    window.scroll(0,0);
    /*let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 100);
      } else {
        window.clearInterval(scrollToTop);
      }}, 16);*/
  }

  toTop(){
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 75); // how far to scroll on each step
      } else {
          window.clearInterval(scrollToTop);
      }
  }, 16);
  }

  

  scroll(el: HTMLElement){
    el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  redirectToFb(): void {
    window.open("https://www.facebook.com/pages/Seng-Hin-Rubber-M-Sdn-Bhd/421439151296044", "_blank");
  }

  redirectToLink(): void {
    window.open("https://www.linkedin.com/in/lee-seng-pin-28ba90129/?originalSubdomain=my", "_blank");
  }

  redirectToMap(): void {
    window.open("https://maps.google.com/maps?ll=5.603963,102.205282&z=16&t=m&hl=en&gl=MY&mapclient=embed&daddr=Seng%20Hin%20Rubber%20(M)%20Sdn.%20Bhd.%20No.%201%2C%20Jalan%20Stapuna%2C%20Kawasan%20Perindustrian%20Sungai%20Nal%2C%20Kelantan%2018000%20Kuala%20Krai@5.6039626,102.2052822", "_blank");
  }

  redirectToWaze(): void {
    window.open("https://ul.waze.com/ul?place=ChIJ-4i42mV8tjERQY6CvZWWzis&ll=5.60396260%2C102.20528220&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location", "_blank");
  }
}
